"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@common/button/Button"));
var react_i18next_1 = require("react-i18next");
function SubmitButton(_a) {
    var editMode = _a.editMode, isSubmittable = _a.isSubmittable, isUpdating = _a.isUpdating, currentItem = _a.currentItem, submitDecision = _a.submitDecision, changeEditMode = _a.changeEditMode;
    var t = (0, react_i18next_1.useTranslation)().t;
    var getButtonText = function () {
        if (editMode) {
            return t('MODERATION.SINGLE_ITEM_VIEW.SUBMIT_BUTTON');
        }
        return isUpdating ? t('MODERATION.SINGLE_ITEM_VIEW.UPDATING_TEXT') : t('MODERATION.SINGLE_ITEM_VIEW.EDIT_BUTTON');
    };
    return (react_1.default.createElement("div", { className: "js-eva-jobs-submit-btn" },
        react_1.default.createElement(Button_1.default, { disabled: (editMode && !isSubmittable) || isUpdating, onClick: function () {
                if (editMode) {
                    submitDecision();
                }
                else {
                    changeEditMode(true, currentItem);
                }
            }, text: getButtonText(), type: "primary", dataCy: "job-submit-changes" })));
}
exports.default = SubmitButton;
